import React from 'react';
import NABLCertificate from "../assets/NABLCertificate.jpg";
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';

const Quality = () => {
  return (
    <>
    <Navbar />
    <div className="flex justify-center items-center min-h-screen bg-gray-100 p-4">
      <div className="flex justify-center">
        <img 
          src={NABLCertificate} 
          alt="Certificate" 
          className="shadow-xl border border-gray-200 rounded"
        />
      </div>
    </div>
    <Footer />
    </>
  );
};

export default Quality;